<template>
  <div>
    <Modal v-model="dialog" :header="false" size="w-3/12">
      <template v-slot:default>
        <div class="flex justify-center mb-3">
          <div
            class="rounded-full w-16 h-16 flex items-center justify-center bg-red-200 border-2 border-red-500 text-red-500 text-4xl">
            <i class="fa-solid fa-xmark"></i>
          </div>
        </div>
        <div class="mb-3 px-3">
          <div class="text-center font-bold text-2xl mb-3">Erro</div>
          <p v-if="!Array.isArray(message)">
            {{ message }}
          </p>
          <ul v-else>
            <li v-for="(item, i) in message" :key="i">
              <span v-html="item" />
            </li>
          </ul>
        </div>
      </template>
      <template v-slot:footer>
        <Button label="Entendi" danger block @click="close" />
      </template>
    </Modal>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'
import { useStore } from 'vuex'
import { computed } from 'vue'

const store = useStore()

const dialog = ref(false)
const message = ref(null)

const errorObject = computed(() => store.state.errorObject)

const close = () => {
  dialog.value = false
  store.dispatch('setError', null)
}

watch(errorObject, (val) => {
  if (val) {
    dialog.value = true
    message.value = val.message
  }
})
</script>
